import { FunctionComponent } from 'react';

import { Box, Typography } from '@sbv-clients/ui-shared';

import SharedAuthLayout from '../../layouts/shared-auth-layout';
import { ResetPasswordProvider } from './providers/reset-password.provider';
import { ResetPasswordForm } from './reset-password-form';

export const SharedResetPasswordPage: FunctionComponent = () => {
  return (
    <ResetPasswordProvider>
      <SharedAuthLayout>
        <Box mb={6} textAlign="center">
          <Typography variant="h1" fontWeight={700} mb={2}>
            Reset your password
          </Typography>
          <Typography>
            We found your SBV account. Choose a new password and enter the code
            we texted you.
          </Typography>
        </Box>
        <ResetPasswordForm />
      </SharedAuthLayout>
    </ResetPasswordProvider>
  );
};
